<template>
    <ul v-if="payments.length" class="pl">
        <li v-for="p in payments" :key="p.id">
            <div class="pl-main">
                <span class="pl-name">{{ p.label || 'Pago' }}</span>
                <span class="pl-amount">${{ money(p.amount) }}</span>
            </div>
            <div class="pl-meta">
                <span>{{ methodLabel(p.paymentMethod) || 'Sin forma de pago' }}</span>
                <span v-if="p.accountName">· {{ p.accountName }}</span>
                <span v-if="Number(p.tip) > 0" class="pl-tip">· + ${{ money(p.tip) }} propina</span>
                <span v-if="p.approvalNumber">· Aprob. {{ p.approvalNumber }}</span>
                <a v-if="p.proofUrl" :href="proofHref(p.proofUrl)" target="_blank" rel="noopener" class="pl-proof">
                    <i class="pi pi-paperclip"></i> comprobante
                </a>
            </div>
        </li>
    </ul>
</template>

<script>
import { methodLabel } from '../../service/paymentRules';

export default {
    name: 'PayerList',
    props: {
        payments: { type: Array, default: () => [] },
    },
    methods: {
        money(value) { return Number(value || 0).toFixed(2); },
        methodLabel,
        // El servidor devuelve la ruta del archivo (/media/…); se abre contra el backend, no el dashboard.
        proofHref(url) {
            if (/^https?:\/\//.test(url)) return url;
            return (this.$baseURL || '').replace(/\/$/, '') + url;
        },
    },
};
</script>

<style scoped>
.pl { list-style: none; margin: 0; padding: 0; }
.pl li { padding: .4rem 0; border-bottom: 1px dashed var(--surface-border); }
.pl-main { display: flex; justify-content: space-between; gap: .5rem; }
.pl-name { font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pl-amount { font-weight: 700; }
.pl-meta { display: flex; flex-wrap: wrap; gap: .25rem; font-size: .76rem; color: var(--text-color-secondary); }
.pl-tip { color: #15803d; }
.pl-proof { color: var(--primary-color); text-decoration: none; display: inline-flex; align-items: center; gap: .15rem; }
.pl-proof:hover { text-decoration: underline; }
</style>
